import React from 'react'
import TabsStrip, { ITab } from '@components/std-components/TabsStrip'
import * as css from './Tabs.css'

export const TAB_KEYS = ['headers', 'subHeaders']

const TABS = [
  {
    id: TAB_KEYS[0],
    name: 'Headers',
    key: 'headers'
  },
  {
    id: TAB_KEYS[1],
    name: 'Sub-headers',
    key: 'subHeaders'
  }
]

export const Tabs: React.FC<any> = React.memo(({ onSelectTab, selectedTab }) => {
  return (
    <div className={css.tabWrapper}>
      <TabsStrip
        tabHeaders={TABS as ITab[]}
        onChange={({ tab }) => {
          onSelectTab(tab)
        }}
        selectedTab={selectedTab}
      />
    </div>
  )
})
